export interface IGetAuthorizedPatientsRequest {
    cadPacienteNo: number;
    cadAutorizacaoCuidadoNo: number;
    showAll: boolean;
}
